import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getPredictors,
  updatePredictors,
  getPredictorById,
} from "api/predictors.api";

export const getPredictorsAsync = createAsyncThunk(
  "predictors/get-all",
  async (filters) => {
    const data = await getPredictors(undefined, filters);
    return data;
  },
);

export const getNextPredictorsAsync = createAsyncThunk(
  "predictors/get-all-next",
  async ({ last, filters }) => {
    const data = await getPredictors(last, filters);
    return data;
  },
);

export const getPredictorByIdAsync = createAsyncThunk(
  "predictor/get-by-id",
  async (id) => {
    const predictor = await getPredictorById(id);
    const response = await fetch(predictor.content);
    const text = await response.text();
    return { ...predictor, content: text };
  },
);

export const updatePredictorAsync = createAsyncThunk(
  "predictor/update",
  async ({ id, data }) => {
    await updatePredictors(id, data);
  },
);
